export default {
	section_banner: {
		title: {
			one: 'Getting',
		},
		main_title: {
			one: 'Started',
		},
		sub_title: {
			one: 'Like A',
			two: 'Bank',
		},
		paragraph: {
			one: 'Everything starts with a business account. Join over 30 million sellers who rely on JPWorldPay to grow and manage their businesses.',
		},
		cta_buttons: {
			one: 'Contact Now',
			two: 'Download App',
		},
	},

	credit_system: {
		label: 'Fastest Payment System',
		title: {
			one: 'Start',
			two: 'Payment',
		},
		paragraph: {
			one: 'Once you confirm your email address and company name and link your JPWorldPay account, you complete your first sales preparation. This simple setup process gets your business ready to accept payments quickly and securely.',
		},
		cta_buttons: {
			one: 'Get Started',
		},
	},

	creditcard_system_inn: {
		label: 'Easy Steps',
		title: {
			one: 'Free',
			two: 'Registration',
		},
		paragraph:
			'You only need an email address and some basic information about your business. Signing up is quick and easy, allowing you to start accepting payments and managing your finances right away. JPWorldPay is designed to make business onboarding smooth, secure, and stress-free.',
		cta_buttons: {
			one: 'Join With Us',
		},
	},

	get_touch_sec: {
		label: 'Easy Settings',
		title: {
			one: 'Get',
			two: 'in Touch',
		},
		paragraph:
			'Inquiry. We will help you. Whether you have questions about your account, need assistance with a transaction, or want to learn more about JPWorldPay’s features, our support team is here for you. Reach out anytime—we’re committed to providing prompt, helpful service to ensure your experience is smooth, worry-free, and always supported by expert guidance and care.',
		cta_buttons: {
			one: 'Connect With Us',
		},
	},

	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
